import { NgModule } from '@angular/core'
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon'

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  GlobalOutline,
  BulbOutline,
  PlayCircleOutline,
  ReadOutline,
  SettingOutline,
} from '@ant-design/icons-angular/icons'

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  // Bundled statically because the SEO hub and its five tabs render them in the
  // sidebar on first paint, before the dynamic icon fetch resolves.
  GlobalOutline,
  BulbOutline,
  PlayCircleOutline,
  ReadOutline,
  SettingOutline,
]

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class IconsProviderModule {}
